import React ,{useEffect,useState,useContext} from "react";
import { Link } from "react-router-dom";
import './bottom.css';
import { AuthContext } from '../user/AuthContext';
import axios from "axios";


const Bottom =()=> {

  const HASH_SECRET = '9e107d9d372bb6826bd81d3542a419d6'; // Same as in AuthContext
  const [user, setUser] = useState(null);
  const { auth } = useContext(AuthContext);

     
  useEffect(() => {
    const userEmail = auth.email; 
    
    if (userEmail) {
        axios.get(`https://quickreact.onrender.com/getUser/${userEmail}`)
            .then(response => {
                console.log(response.data);
                setUser(response.data); 
            })
            .catch(error => console.log("User not found"));
    }
       }, [auth]); 
  

  
    return (
    <div>
        <h1 id="nomore">No More Subscriptions 🎉 Enjoy Lifetime Offers on Everything!</h1>
         <div className="pricing">
          <div className="tire">
            <h1>Basic Tier</h1>
            <h1>
              <s>9.99$</s> 2.99$
            </h1>    
            <ul>
              <li><svg width="40px" height="30px" viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg" aria-labelledby="okIconTitle" stroke="#00FF00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" color="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title id="okIconTitle">Ok</title> <polyline points="4 13 9 18 20 7"></polyline> </g></svg>Basic Component</li>
              <li><svg width="40px" height="30px" viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg" aria-labelledby="okIconTitle" stroke="#00FF00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" color="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title id="okIconTitle">Ok</title> <polyline points="4 13 9 18 20 7"></polyline> </g></svg>24/7 Support</li>
              <li><svg width="40px" height="30px" viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg" aria-labelledby="okIconTitle" stroke="#00FF00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" color="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title id="okIconTitle">Ok</title> <polyline points="4 13 9 18 20 7"></polyline> </g></svg>Life time</li>
              <li><svg fill="#FF0000" width="40px" height="30px" viewBox="0 0 200 200" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><title></title><path d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z"></path></g></svg>Full Access</li>
  
            </ul>
              {user && !user.isSubscribed && ( 
                 <Link to="/Basic">Get Started Now</Link>
              )}
              {user && user.isSubscribed && (
                 <Link to="/start">Get Started Now</Link>
              )}
              {!user &&(
                 <Link to="/login">Get Started Now</Link>
               )}
          </div>
          <div className="tire" id="paid">
            <h2>Best Offer</h2>
            <h1>Premium Tier</h1>
            <h1>
              <s>23.99$</s> 4.99$
            </h1>
            <ul>
              <li><svg width="40px" height="30px" viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg" aria-labelledby="okIconTitle" stroke="#00FF00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" color="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title id="okIconTitle">Ok</title> <polyline points="4 13 9 18 20 7"></polyline> </g></svg>Premium Component</li>
              <li><svg width="40px" height="30px" viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg" aria-labelledby="okIconTitle" stroke="#00FF00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" color="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title id="okIconTitle">Ok</title> <polyline points="4 13 9 18 20 7"></polyline> </g></svg>Priority Support</li>
              <li><svg width="40px" height="30px" viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg" aria-labelledby="okIconTitle" stroke="#00FF00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" color="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title id="okIconTitle">Ok</title> <polyline points="4 13 9 18 20 7"></polyline> </g></svg>Full Access</li>
              <li><svg width="40px" height="30px" viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg" aria-labelledby="okIconTitle" stroke="#00FF00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" color="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title id="okIconTitle">Ok</title> <polyline points="4 13 9 18 20 7"></polyline> </g></svg>Life time</li>
              <li><svg width="40px" height="30px" viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg" aria-labelledby="okIconTitle" stroke="#00FF00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" color="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title id="okIconTitle">Ok</title> <polyline points="4 13 9 18 20 7"></polyline> </g></svg>Ask For edit</li>
  
            </ul>
             {user && !user.isPremium && ( 
                 <Link to="/Premium">Get Started Now</Link>
              )}
              {user && user.isPremium && (
                 <Link to="/start">Get Started Now</Link>
              )}
              {!user &&(
                 <Link to="/login">Get Started Now</Link>
               )}

          </div>
        </div>
     </div>
    )
}

export default Bottom;